import { render } from "./NotificationSettingModal.vue?vue&type=template&id=5feee418&scoped=true"
import script from "./NotificationSettingModal.vue?vue&type=script&lang=js"
export * from "./NotificationSettingModal.vue?vue&type=script&lang=js"

import "./NotificationSettingModal.vue?vue&type=style&index=0&id=5feee418&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5feee418"]])

export default __exports__